import React from 'react';
import styles from './styles.scss';

export default () => {
  return (
    <span className={styles.loadingDots}>
      <span className={styles.dot} />
      <span className={styles.dot} />
      <span className={styles.dot} />
    </span>
  );
}



// WEBPACK FOOTER //
// ./src/components/common/DotLoader/index.js